// extracted by mini-css-extract-plugin
export default {"input":"_5Jwwg","wrapper":"SO0qb","checkbox":"GIbHR","label":"oDt-y"};